function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4319 6.5L17.9319 3M19.9319 1L17.9319 3L19.9319 1ZM10.3219 10.61C10.8383 11.1195 11.2487 11.726 11.5297 12.3948C11.8106 13.0635 11.9565 13.7813 11.9589 14.5066C11.9614 15.232 11.8203 15.9507 11.5438 16.6213C11.2674 17.2919 10.861 17.9012 10.3481 18.4141C9.83515 18.9271 9.22584 19.3334 8.55522 19.6099C7.8846 19.8864 7.16591 20.0275 6.44055 20.025C5.71518 20.0226 4.99746 19.8767 4.32871 19.5958C3.65995 19.3148 3.05338 18.9043 2.54392 18.388C1.54205 17.3507 0.987677 15.9614 1.00021 14.5193C1.01274 13.0772 1.59117 11.6977 2.61091 10.678C3.63066 9.65825 5.01013 9.07982 6.45221 9.06729C7.89429 9.05476 9.2836 9.60913 10.3209 10.611L10.3219 10.61ZM10.3219 10.61L14.4319 6.5L10.3219 10.61ZM14.4319 6.5L17.4319 9.5L20.9319 6L17.9319 3L14.4319 6.5Z",
  stroke: "#9199AA",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.19943cd4.svg";
export { ForwardRef as ReactComponent };